// import {CreateElement} from "../../Utilities/CreateElement";
//
// export class Clock {
//     dom: HTMLElement;
//
//     constructor() {
//         this.dom = CreateElement(`<p class="align-middle pb-0 mb-0 fw-semibold"></p>`);
//         setInterval(() => {
//             this.updateTime()
//         }, 1000);
//         this.updateTime();
//     }
//
//     updateTime() {
//         const date = new Date();
//         const weekDay = ["Sun", "Mon", "Tues", "Wed", "Fri", "Sat"][date.getDay()];
//         const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"][date.getMonth()];
//         const monthDay = date.getDate();
//         const hour = date.getHours();
//         const minutes = date.getMinutes();
//         this.dom.innerText = `${weekDay}, ${monthName} ${monthDay}  ${hour}:${minutes}`;
//     }
// }

import {TaskbarMenuEntry} from "./TaskbarMenuEntry";
import {CreateElement} from "../../Utilities/CreateElement";

export class ClockWidget extends TaskbarMenuEntry {
    constructor() {
        super(CreateElement(`<p class="align-middle pb-0 mb-0 fw-semibold"></p>`));
        setInterval(() => this.updateTime(), 1000);
    }

    updateTime() {
        const date = new Date();
        const weekDay = ["Sun", "Mon", "Tues", "Wed", "Fri", "Sat"][date.getDay()];
        const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"][date.getMonth()];
        const monthDay = date.getDate();
        const hour = date.getHours();
        const minutes = date.getMinutes();
        this.widget.innerText = `${weekDay}, ${monthName} ${monthDay}  ${hour}:${minutes}`;
    }
}